import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  ResetPasswordFlowContext,
  ResetPasswordProfile
} from '../../core/services/reset-password-flow.context';
import { ResetPasswordService } from '../../core/services/reset-password.service';

@Component({
  selector: 'app-token-virtual-admin',
  templateUrl: './token-virtual-admin.component.html',
  styleUrls: ['./token-virtual-admin.component.css'],
  standalone: false
})
export class TokenVirtualAdminComponent implements OnInit, OnDestroy {
  stepActual = 1;
  profile: ResetPasswordProfile = 'token-virtual';
  private flowStarted = false;
  private readonly destroy$ = new Subject<void>();

  readonly progressSteps: { key: number; title: string; desc: string; icon: string; tone: string }[] = [
    { key: 1, title: 'Identificar', desc: 'Documento', icon: 'fas fa-id-card', tone: 'tone-blue' },
    { key: 2, title: 'Verificar', desc: 'Contacto', icon: 'fas fa-address-book', tone: 'tone-teal' },
    { key: 3, title: 'Código', desc: 'OTP', icon: 'fas fa-key', tone: 'tone-violet' },
    { key: 4, title: 'Nueva clave', desc: 'Contraseña', icon: 'fas fa-lock', tone: 'tone-amber' },
    { key: 5, title: 'Listo', desc: 'Confirmación', icon: 'fas fa-circle-check', tone: 'tone-green' }
  ];

  /**
   * Paso visual del timeline (1–5).
   * stepActual 1–4 mapean 1:1; éxito (6) → 5.
   */
  get progressStep(): number {
    if (this.stepActual >= 6) return 5;
    if (this.stepActual === 5) return 4;
    return this.stepActual;
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private flowContext: ResetPasswordFlowContext,
    private resetPasswordService: ResetPasswordService
  ) {}

  ngOnInit(): void {
    const parentData = this.route.parent?.snapshot.data ?? this.route.snapshot.data;
    const nextProfile: ResetPasswordProfile =
      parentData['resetProfile'] === 'ccsw5' || this.route.snapshot.data['resetProfile'] === 'ccsw5'
        ? 'ccsw5'
        : 'token-virtual';

    this.route.parent?.data.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      this.applyProfile(data['resetProfile'] === 'ccsw5' ? 'ccsw5' : 'token-virtual');
    });

    // Fallback si no hay padre (rutas legacy directas)
    this.route.data.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      if (data['resetProfile']) {
        this.applyProfile(data['resetProfile'] === 'ccsw5' ? 'ccsw5' : 'token-virtual');
      }
    });

    this.applyProfile(nextProfile);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.flowContext.setProfile('token-virtual');
  }

  private applyProfile(nextProfile: ResetPasswordProfile): void {
    const profileChanged = nextProfile !== this.profile;
    this.profile = nextProfile;
    this.flowContext.setProfile(this.profile);
    if (!this.flowStarted || profileChanged) {
      this.resetPasswordService.clearFlowStorage();
      this.stepActual = 1;
      this.flowStarted = true;
    }
  }

  isStepDone(stepKey: number): boolean {
    return this.progressStep > stepKey;
  }

  isStepCurrent(stepKey: number): boolean {
    return this.progressStep === stepKey;
  }

  nextStep(): void {
    if (this.stepActual === 4) {
      this.stepActual = 6;
    } else {
      this.stepActual++;
    }
  }

  previousStep(): void {
    if (this.stepActual > 1) this.stepActual--;
  }

  resetFlow(): void {
    this.resetPasswordService.clearFlowStorage();
    this.stepActual = 1;
  }

  onCancelar(): void {
    this.resetPasswordService.clearFlowStorage();
    this.stepActual = 1;
  }

  closeAndNavigate(): void {
    this.router.navigate(['/firmar']);
  }
}
